/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DefinitionMargins
 */
export interface DefinitionMargins {
    /**
     * 
     * @type {number}
     * @memberof DefinitionMargins
     */
    left?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DefinitionMargins
     */
    right?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DefinitionMargins
     */
    firstLine?: number | null;
}

export function DefinitionMarginsFromJSON(json: any): DefinitionMargins {
    return DefinitionMarginsFromJSONTyped(json, false);
}

export function DefinitionMarginsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DefinitionMargins {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'left': !exists(json, 'left') ? undefined : json['left'],
        'right': !exists(json, 'right') ? undefined : json['right'],
        'firstLine': !exists(json, 'firstLine') ? undefined : json['firstLine'],
    };
}

export function DefinitionMarginsToJSON(value?: DefinitionMargins | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'left': value.left,
        'right': value.right,
        'firstLine': value.firstLine,
    };
}


